import React from "react";
import {
  AddressKeys,
  AddressStateType,
  AddressStatusType,
  AutoCompleteSuggestionType,
} from "core-lib/types/Address";
import useReverseGeoCode, {
  ReverseGeoCodeType,
} from "../../services/useReverseGeoCode";
import useAutoComplete from "./useAutoComplete";

type AutoCompleteWrapperTypes = {
  address: AddressStateType;
  suggestions: AutoCompleteSuggestionType[];
  query: string;
  fetch: (givenLocatoion?: { lat: number; lng: number }) => void;
  updateQuery: (args: string) => void;
  selectPlaceId: (data: AutoCompleteSuggestionType) => void;
  reset: () => void;
  suggestionAPiStatus: string;
};

export default function useAutoCompleteWithRGC({
  rgc = {
    enableRGCApi: true,
    enableFallbackRGCApi: false,
  },
  addressValidation = ["pincode"],
}: {
  rgc?: ReverseGeoCodeType;
  addressValidation?: AddressKeys[];
}): AutoCompleteWrapperTypes {
  const [address, setAddress] = React.useState<AddressStateType>({
    status: AddressStatusType.Default,
    data: null,
  });
  const { address: rgcAddress, fetch: fetchRGC } = useReverseGeoCode({
    ...rgc,
    addressValidation,
  });
  const {
    address: placeDetailAddress,
    suggestions,
    query,
    updateQuery,
    selectPlaceId,
    reset,
    suggestionAPiStatus,
  } = useAutoComplete();

  React.useEffect(() => {
    if (placeDetailAddress.status === AddressStatusType.Success) {
      const isValid = addressValidation.every(
        (el) => placeDetailAddress.data[el]
      );
      if (isValid) {
        setAddress(placeDetailAddress);
      } else {
        fetchRGC({
          lat: +placeDetailAddress.data.latitude,
          lng: +placeDetailAddress.data.longitude,
        });
      }
    } else if (placeDetailAddress.status === AddressStatusType.Failed) {
      setAddress(placeDetailAddress);
    }
  }, [placeDetailAddress]);

  React.useEffect(() => {
    if (rgcAddress.status !== AddressStatusType.Default) {
      setAddress(rgcAddress);
    }
  }, [rgcAddress]);

  return {
    address,
    suggestions,
    query,
    fetch: fetchRGC,
    updateQuery,
    selectPlaceId,
    reset,
    suggestionAPiStatus,
  };
}
